import api from './axios';

export function createSimulationContribution(data) {
  return api.post('/simulation-contributions', data).then(res => res.data);
}

export function listSimulationContributions(simulationId) {
  return api.get(`/simulation-contributions/${simulationId}`).then(res => res.data);
}

export function updateSimulationContribution(id, data) {
  return api.put(`/simulation-contributions/${id}`, data).then(res => res.data);
}

export function deleteSimulationContribution(id) {
  return api.delete(`/simulation-contributions/${id}`);
}
